'use client'

import { ChevronRightIcon } from '@repo/ui/ChevronRightIcon'
import MUIIconButton from '@mui/material/IconButton'
import MUIStack from '@mui/material/Stack'
import MUITooltip from '@mui/material/Tooltip'
import MUITypography from '@mui/material/Typography'
import PropTypes from 'prop-types'

export const CustomDataPageMenu = ({ pages, handlePageClick, handleFieldClick, setPageIsOpen, scrollRef }) => {
  return (
    <MUIStack
      data-testid="CustomDataPageMenu"
      direction="column"
      sx={{
        width: '350px',
        minWidth: '350px',
        overflowY: 'auto',
        height: '100%',
        paddingRight: '60px',
        position: 'relative'
      }}
      gap={'0px'}
      ref={scrollRef}
    >
      {pages?.map((page) => (
        <div key={page.customDataPageId} id={`custom-data-page-menu-${page.customDataPageId}`}>
          <MUIStack direction="row" alignItems="center" gap={'2px'}>
            <MUIIconButton
              onClick={() => setPageIsOpen({ pageId: page.customDataPageId, isOpen: !page.isOpen })}
              sx={{ padding: 0 }}
            >
              <ChevronRightIcon
                sx={{ height: '28px', color: '#3D517B8F', transform: `rotate(${page.isOpen ? 90 : 0}deg)` }}
              />
            </MUIIconButton>
            <MUITooltip title={page.description?.length > 28 ? page.description : ''} placement="top" arrow>
              <MUITypography
                variant="body1"
                sx={{
                  cursor: 'pointer',
                  height: '28px',
                  fontSize: '1rem',
                  fontWeight: 600,
                  padding: '4px 0',
                  mb: 0
                }}
                onClick={() => handlePageClick({ page })}
                noWrap
              >
                {page.description}
              </MUITypography>
            </MUITooltip>
          </MUIStack>

          <MUIStack
            direction="column"
            gap={'4px'}
            sx={{
              mt: '8px',
              overflow: 'hidden',
              height: page?.isOpen ? page?.fields?.length * 32 + 4 : 0
            }}
          >
            {page?.fields?.map((field) => (
              <MUITooltip
                placement="top"
                arrow
                key={field.customDataFieldId || field.fieldId}
                title={field.description?.length > 33 ? field.description : ''}
              >
                <MUITypography
                  variant="body1"
                  sx={{ ml: '50px', height: '28px', mb: 0, cursor: 'pointer' }}
                  onClick={() => handleFieldClick({ page, field })}
                  id={`custom-data-field-menu-${page.customDataPageId}-${field.customDataFieldId || field.fieldId}`}
                  noWrap
                >
                  {field.description}
                </MUITypography>
              </MUITooltip>
            ))}
          </MUIStack>
        </div>
      ))}
    </MUIStack>
  )
}

CustomDataPageMenu.propTypes = {
  pages: PropTypes.array,
  handlePageClick: PropTypes.func,
  handleFieldClick: PropTypes.func,
  setPageIsOpen: PropTypes.func,
  scrollRef: PropTypes.object
}
